import { createFileRoute } from '@tanstack/react-router';
import { OnboardingPage } from '@/features/metric-hub/onboarding/OnboardingPage';

export const Route = createFileRoute('/_authed/metric-hub/onboarding')({
  component: OnboardingPage,
});
